import React from "react";

import { IPanelProps, Panel } from "core/decorators/Panel";
import { ArticleEdit } from "./article/ArticleEdit";
import ArticlePanelConfig from "./config/ArticlePanelConfig";
import constants from "./constants";

@Panel({
	id: "kb-article",
	configClass: ArticlePanelConfig,
	pageParams: true
})
class ArticlePanel extends React.Component<IPanelProps<ArticlePanelConfig>> {
	public render() {
		const { config, pageParams } = this.props;

		const key: React.Key = pageParams[constants.PARAM_ARTICLE_ID];

		return (
			<ArticleEdit
				key={key}
				articleId={pageParams[constants.PARAM_ARTICLE_ID]}
				layout={config.layout}
				categoryRefId={pageParams[constants.PARAM_CATEGORY_ID]}
				knowledgeBaseId={pageParams[constants.PARAM_KB_ID]}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/kb/Article.panel.tsx